export const MY_ACCOUNT = "my account"
export const NAVIGATION = "navigation"
export const WISHLIST_SAVE = "wishlist save"
export const NEWEST_TO_OLDEST = "newest to oldest"
export const OLDEST_TO_NEWEST = "oldest to newest"
export const LISTS = "lists"